import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import MainLogo from "assets/images/icons/logo-qw-light.png";
import GfnLogo from "assets/images/icons/logo1.png";
// import CartLogo from 'assets/images/icons/cart.svg'
import { Link, useLocation } from "react-router-dom";
import { Navbar, Container, Button, Spinner, Nav, NavDropdown } from "react-bootstrap";
import ModalRegisterSimple from "layouts/ModalRegisterSimple";
import ModalLogin from "layouts/ModalLogin";

const NavbarComponent = () => {
  const location = useLocation();
  const [showLogin, setModalLogin] = useState(false);
  const [showDaftar, setModalDaftar] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const isLogin = useSelector((state) => state.auth.status_login);
  const isLoading = useSelector((state) => state.auth.status);
  const redirectUrl = useSelector((state) => state.auth.redirectUrl);
  const userData = useSelector((state) => state.auth.data_login?.client);
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Selamat Pagi,";
    if (hour < 15) return "Selamat Siang,";
    if (hour < 19) return "Selamat Sore,";
    return "Selamat Malam,";
  };

  const getUserName = () => {
    if (!userData) return "";
    const firstName = userData.firstname || "";
    const lastName = userData.lastname || "";
    return `${firstName} ${lastName}`.trim();
  };

  const handlerLogout = async (e) => {
    e.preventDefault();
    setIsLogoutLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API}logout.php`, {
        method: "GET",
        credentials: "include",
      });
      await response.text();
      window.location.reload();
    } catch (err) {
      console.error("Logout error:", err);
      window.location.reload();
    } finally {
      setIsLogoutLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading === "idle" && redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [isLoading, redirectUrl]);

  return (
    <Navbar 
      bg="white" 
      expand="lg" 
      className="py-0 py-lg-3 sticky-top" 
      id="navCheckout"
      expanded={expanded}
      onToggle={(expanded) => setExpanded(expanded)}
    >
      <Container fluid>
        <Navbar.Toggle 
          aria-controls="navbarTogglerDemo01" 
          className="border-0"
        />
        
        <Navbar.Brand 
          as={Link} 
          to="/" 
          className="me-2"
        >
          <img src={GfnLogo} alt="client.goldenfast.net" width="140px" />
        </Navbar.Brand>

        <Navbar.Collapse id="navbarTogglerDemo01" className="ms-auto">
          {/* Navigation Menu */}
          <Nav className="me-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={location.pathname === "/" ? "fw-bold active" : "fw-bold"}
              style={location.pathname === "/" ? {color: '#F8B038'} : {}}
            >
              Beranda
            </Nav.Link>
            
            <NavDropdown title="Layanan" id="layanan-dropdown">
              <NavDropdown.Item as={Link} to="/orderserver">
                Pesan Layanan Baru
              </NavDropdown.Item>
            </NavDropdown>
            
            <NavDropdown title="Domain" id="domain-dropdown">
              <NavDropdown.Item as={Link} to="/orderdomain">
                Daftar Domain Baru
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/orderdomain?type=transfer">
                Transfer Domain ke Jejaring Cepat
              </NavDropdown.Item>
            </NavDropdown>
            
            <NavDropdown title="Support" id="support-dropdown">
              <NavDropdown.Item href={`${process.env.REACT_APP_BASE_API}submitticket.php`} target="_blank">
                Buka Ticket
              </NavDropdown.Item>
            </NavDropdown>
            
            <Nav.Link href={`${process.env.REACT_APP_BASE_API}affiliates.php`} target="_blank">
              Afiliasi
            </Nav.Link>
            
            <NavDropdown title="Tentang Kami" id="tentang-dropdown">
              <NavDropdown.Item href="https://www.goldenfast.net/tentang-kami/" target="_blank">
                GoldenFast Network
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.ItemText className="fw-bold">Pemesanan dan Pembayaran</NavDropdown.ItemText>
              <NavDropdown.Item href="https://www.goldenfast.net/pembayaran/permintaan-faktur-pajak/" target="_blank">
                Faktur Pajak
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="https://www.goldenfast.net/tentang-kami/fasilitas-data-center/" target="_blank">
                Fasilitas Data Center
              </NavDropdown.Item>
              <NavDropdown.Item href="https://www.goldenfast.net/tentang-kami/informasi-jaringan/" target="_blank">
                Informasi Jaringan
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.ItemText className="fw-bold">Master Service Aggreement</NavDropdown.ItemText>
              <NavDropdown.Item href="https://www.goldenfast.net/tentang-kami/master-service-agreement/migrasi-pelanggan/" target="_blank">
                Migrasi Pelanggan
              </NavDropdown.Item>
              <NavDropdown.Item href="https://www.goldenfast.net/tentang-kami/master-service-agreement/peraturan-pengembalian-dana/" target="_blank">
                Peraturan Pengembalian Dana
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          {/* Account Section */}
          <Nav className="ms-auto">
            {isLogin ? (
              <div className="d-flex align-items-center gap-3">
                <div className="d-none d-lg-block text-end">
                  <small className="text-muted d-block">{getGreeting()}</small>
                  <span className="fw-bold">{getUserName()}</span>
                </div>
                <div className="vr d-none d-lg-inline-block"></div>
                <Button 
                  className="btn btn-outline-qw-primary mx-1 rounded-5 bg-white fw-bold"
                  onClick={handlerLogout}
                  disabled={isLogoutLoading}
                >
                  {isLogoutLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                        variant="light" // atau "primary" jika ingin orange
                      />
                      Keluar
                    </>
                  ) : (
                    "Keluar"
                  )}
                </Button>
              </div>
            ) : (
              <div className="d-flex gap-3">
                <div className="vr me-3 d-none d-lg-inline-block"></div>
                <Button
                  className="btn btn-outline-qw-primary me-0 rounded-5 bg-white fw-bold"
                  onClick={() => {
                    setModalDaftar(true);
                    setExpanded(false);
                  }}
                >
                  Daftar
                </Button>

                <Button
                  className="btn btn-outline-qw-primary rounded-5 bg-white fw-bold"
                  onClick={() => {
                    setModalLogin(true);
                    setExpanded(false);
                  }}
                >
                  Masuk
                </Button>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>

        <ModalRegisterSimple
          show={showDaftar}
          onHide={() => setModalDaftar(false)}
          onClickDaftar={setModalDaftar}
          onClickLogin={setModalLogin}
        />

        <ModalLogin
          show={showLogin}
          onHide={() => setModalLogin(false)}
          onClickDaftar={setModalDaftar}
          onClickLogin={setModalLogin}
        />
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
